import CONSTANTS from '@/constants'

const {
  INE_PREMIUM_EDA,
  INE_PREMIUM_EWPT_PREMIUM,
  INE_PREMIUM_ECPPT,
} = CONSTANTS.PLANS.PREMIUM_PLANS

const { EJPT_FUNDAMENTALS } = CONSTANTS.PLANS

export const plansCPEHydratation = merchant_id => {
  let current = {}
  switch (merchant_id) {
    case EJPT_FUNDAMENTALS:
      current.short_name = 'eJPT'
      current.info = '+ 3 months of Fundamentals*'
      current.text = 'Junior Penetration Tester exam voucher'
      current.infoExtra =
        '*Renewal: $350 after 3 months, then $749 annually from purchase date.'
      break
    case INE_PREMIUM_EDA:
      current.short_name = 'eEDA'
      current.info = '+ 3 months of Premium*'
      current.text = 'Enterprise Defense Associate exam voucher'
      current.infoExtra =
        '*Renewal: $350 after 3 months, then $749 annually from purchase date.'
      break
    case INE_PREMIUM_EWPT_PREMIUM:
      current.short_name = 'eWPT'
      current.info = '+ 3 months of Premium*'
      current.text = 'Web-application Penetration Tester exam voucher'
      current.infoExtra =
        '*Renewal: $350 after 3 months, then $749 annually from purchase date.'
      break
    case INE_PREMIUM_ECPPT:
      current.short_name = 'eCPPT'
      current.info = '+ 3 months of Premium*'
      current.text = 'Certified Professional Penetration Tester exam voucher'
      current.infoExtra =
        '*Renewal: $350 after 3 months, then $749 annually from purchase date.'
      break
    default:
      break
  }
  return current
}
